import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home/index.jsx";
import NavBar from "./componet/NavBar/index.jsx";
import Footer from "././componet/Footer/index.jsx";
import { Blur } from "./pages/Home/styled.js";

const Navigator = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <BrowserRouter>
      <Blur openMenu={openMenu}></Blur>
      <NavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
      <Routes>
        <Route
          path="/"
          element={<Home openMenu={openMenu} setOpenMenu={setOpenMenu} />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default Navigator;
